import React from "react";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Filler,
} from "chart.js";

ChartJS.register(
  LineElement,
  CategoryScale,
  LinearScale,
  PointElement,
  Tooltip,
  Filler
);

const DashboardLineChart = ({ updatingClickData, data, clicks }) => {
  const options = {
    aspectRatio: 5 / 2,
    responsive: true,
    plugins: {
      tooltip: {
        callbacks: {
          label: function (context) {
            let label = context.dataset.label || "";

            if (label) {
              label += ": ";
            }
            if (context.parsed.y !== null) {
              label += new Intl.NumberFormat("en-US", {}).format(
                context.parsed.y
              );
            }
            return label;
          },
        },
      },
    },
    scales: {
      y: {
        grid: {
          display: false,
        },
        ticks: {
          display: false,
        },
      },
      x: {
        grid: {
          display: false,
        },
        ticks: {
          display: false,
        },
      },
    },
  };
  return (
    <div className="w-full">
      <div className="w-full bg-white dark:bg-accent-700 pt-20px rounded-lg overflow-hidden shadow-sm border border-primary-50 dark:border-none relative">
        {updatingClickData && (
          <div className="absolute bg-[rgba(255, 255, 255, 0.5)] backdrop-blur-sm z-[9999] top-0 bottom-0 right-0 left-0 flex justify-center items-center">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              xmlnsXlink="http://www.w3.org/1999/xlink"
              width="32px"
              height="32px"
              viewBox="0 0 100 100"
              preserveAspectRatio="xMidYMid"
            >
              <circle
                cx="50"
                cy="50"
                r="32"
                strokeWidth="8"
                stroke="#9188ff"
                strokeDasharray="50.26548245743669 50.26548245743669"
                fill="none"
                strokeLinecap="round"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  repeatCount="indefinite"
                  dur="1s"
                  keyTimes="0;1"
                  values="0 50 50;360 50 50"
                ></animateTransform>
              </circle>
            </svg>
          </div>
        )}
        <div className="total-clicks | absolute left-20px top-20px z-[999]">
          <div className="font-medium text-lg text-primary-400 dark:text-primary-200 bg-white dark:bg-accent-700 w-fit mb-0 leading-4">
            {clicks}
          </div>
          <label className="dark:bg-accent-700 text-xs text-primary-300 bg-white w-fit">
            Clicks to date
          </label>
        </div>
        <Line
          className="w-full scale-[1.06]"
          data={data}
          options={options}
        ></Line>
      </div>
    </div>
  );
};

export default DashboardLineChart;
